const platformMarkerColumn = () => ({
	name: "platformMarker",
	type: "input" as const,
	placeholder: "Platform Marker",
});

export default platformMarkerColumn;
